import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { actions } from 'features/reports/redux';
import { actions as usersActions } from 'features/users/redux';

const banks = [
  { value: 'CBU', name: 'CBU' },
  { value: 'Alias', name: 'Alias' },
];

const useCBU = () => {
  const actionProcessing = useSelector(s => s.reports.actionProcessing);
  const currentRequisites = useSelector(s => s.users.profile);

  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [values, setValues] = useState(() => ({
    titular: '',
    activeBankSelector: { value: 'CBU', name: 'CBU' },
    details: '',
    openedItemId: null,
    addRequisites: false,
  }));

  const handleValueChange = (name, value) => {
    setValues(ps => ({
      ...ps,
      [name]: value,
    }));
  };

  const handleCreateBank = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(
        actions.createBank(
          { titular: values.titular, bank: values.activeBankSelector.value, details: values.details },
          () => {
            dispatch(usersActions.getProfileInfo());
            setIsModalOpen(false);
          },
        ),
      );
    }
  };

  const handleUpdateBank = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(
        actions.updateBank(
          {
            titular: values.titular,
            bank: values.activeBankSelector.value,
            details: values.details,
            id: values.openedItemId,
          },
          () => {
            dispatch(usersActions.getProfileInfo());
            setIsModalOpen(false);
          },
        ),
      );
    }
  };

  const handleDeleteBank = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(
        actions.deleteBank(
          {
            id: values.openedItemId,
          },
          () => {
            dispatch(usersActions.getProfileInfo());
            setIsModalOpen(false);
            handleValueChange('openedItemId', null);
          },
        ),
      );
    }
  };

  const handleSelectBank = itemValue => {
    setValues(ps => ({
      ...ps,
      activeBankSelector: { value: itemValue, name: itemValue },
    }));
  };

  const handleAddRequisites = itemValue => {
    setValues(ps => ({
      ...ps,
      addRequisites: itemValue,
      openedItemId: null,
    }));
  };

  const toggleItem = id => {
    setValues(ps => ({
      ...ps,
      openedItemId: ps.openedItemId === id ? null : id,
      addRequisites: false,
    }));
  };

  useEffect(() => {
    const filteredItem = currentRequisites.filter(requisite => requisite.id === values.openedItemId)[0];

    values.openedItemId &&
      setValues(ps => ({
        ...ps,
        titular: filteredItem.titular,
        details: filteredItem.details,
        activeBankSelector: { value: filteredItem.bank, name: filteredItem.bank },
      }));
  }, [values.openedItemId, currentRequisites]);

  useEffect(() => {
    dispatch(usersActions.getProfileInfo());
  }, []);

  return {
    state: {
      values,
      isModalOpen,
      currentRequisites,
    },
    handlers: {
      setIsModalOpen,
      handleValueChange,
      handleCreateBank,
      handleSelectBank,
      toggleItem,
      handleAddRequisites,
      handleUpdateBank,
      handleDeleteBank,
    },
    out: {
      banks,
    },
  };
};

export default useCBU;
